import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { requestDownloadOriginFile } from "store/project/reducer";
import { selectedProjectSelector } from "store/project/selector";
import { alertSelector } from "store/ui/selector";

interface UseProjectActionsReturn {
  successMessage: string;
  errorMessage: string;
  onDownloadFiles: (type: string) => void;
  onAddService: (serviceName: string) => void;
  clearMessages: () => void;
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
}

export const useProjectActions = (): UseProjectActionsReturn => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const selectedProject = useSelector(selectedProjectSelector);
  const alert = useSelector(alertSelector);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setSuccessMessage("");
    setErrorMessage("");
  }, [id]);

  useEffect(() => {
    if (alert?.type === "success" && alert?.message) {
      setSuccessMessage(alert.message);
    } else if (alert?.type === "error" && alert?.message) {
      setErrorMessage(alert.message);
    }
  }, [alert]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 15000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(""), 15000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const onDownloadFiles = (type: string) => {
    dispatch(
      requestDownloadOriginFile({
        order_id: id,
        user_role: "customer",
        type: type,
        file_name: `${selectedProject?.order?.order_name || 'project'}-${type}-files.zip`,
      })
    );
  };

  const onAddService = (serviceName: string) => {
    // TODO: заменить на реальный запрос для добавления услуги.
    // Пока имитируем успешное добавление и очищаем возможную ошибку.
    setErrorMessage("");
    setSuccessMessage("Service added to your order.");
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const clearMessages = useCallback(() => {
    setSuccessMessage("");
    setErrorMessage("");
  }, []);

  return {
    successMessage,
    errorMessage,
    onDownloadFiles,
    onAddService,
    clearMessages,
    setSuccessMessage,
    setErrorMessage,
  };
};
